export const navbarMenus = [
  {
    label: 'Home',
    path: 'dashboard',
    icon: 'dashboard',
    role: ['lojista', 'cliente', 'admin'],
  },
  // {
  //   label: 'Vendas',
  //   path: 'sales',
  //   icon: 'sales',
  //   role: ['lojista', 'cliente', 'admin'],
  // },
  // {
  //   label: 'Financeiro',
  //   path: 'finance',
  //   icon: 'finance',
  //   role: ['lojista', 'cliente', 'admin'],
  // },
  {
    label: 'Transações',
    path: 'transactions',
    icon: 'coins',
    role: ['lojista', 'cliente'],

    notification: true,
  },
  // {
  //   label: 'Mensagens',
  //   path: 'mail',
  //   icon: 'mail',
  //   role: ['lojista', 'cliente', 'admin'],

  //   notification: true,
  // },
  {
    label: 'Estabelecimentos',
    path: 'estabelecimento',
    icon: 'merchant',
    role: ['cliente'],
  },
  {
    label: 'Gerenciamento',
    path: 'gerenciamento',
    icon: 'internet',
    role: ['lojista', 'cliente', 'admin'],
    children: [
      {
        label: 'Checkouts',
        path: 'checkout',
        icon: 'clients',
      },
      // {
      //   label: 'Terminais',
      //   path: 'terminal',
      //   icon: 'clients',
      // },
    ],
  },
  {
    label: 'Configurações',
    path: 'settings',
    icon: 'settings',
    role: ['lojista', 'cliente'],
  },
  {
    label: 'Administração',
    path: 'admin',
    icon: 'admin',
    role: ['admin'],
    children: [
      {
        label: 'Clientes',
        path: 'clientes',
        icon: 'clients',
      },
      {
        label: 'Logs',
        path: 'logs',
        icon: '',
      },
      {
        label: 'MQTT Monitor',
        path: 'mqttMonitor',
        icon: '',
      },
      {
        label: 'Estabelecimentos',
        path: 'estabelecimentos',
        hidden: true,
      },
      {
        label: 'Usuários',
        path: 'users',
        hidden: true,
      },
    ],
  },
  {
    label: 'Api/Doc',
    path: 'dev',
    icon: 'dev',
    role: ['lojista', 'cliente', 'admin'],
  },
];
